import React, {useCallback} from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import '/src/i18n';
import store from './Redux/store';
import App from './App';

const renderComponent = (id, Component) => {
	const rootElement = document.getElementById(id);
  	if (rootElement) {
    	const root = createRoot(rootElement);
    	root.render(
    		<Provider store={store}>
    			<Component {...rootElement.dataset} />
    		</Provider>
    	);
  	}
};

renderComponent("form-inputs", App);